/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class GlobalVar extends React.Component {
  render() {
    return <div>
        {this.props.children}
    </div>
  }
};
export default GlobalVar;


// WEBPACK FOOTER //
// ./src/routes/globalVar/index.js